// extracted by mini-css-extract-plugin
export var icon = "_b3-3";
export var subtitle = "_b3-2";
export var title = "_b3-1";
export var value = "_b3-0";